{
  "title": "Settings",
  "description": "Manage your school. Only administrators can see this page.",
  "school": {
    "title": "School",
    "name": "Name",
    "slug": "Web address (slug)",
    "type": "Type",
    "types": {
      "organization": "Organization",
      "individual": "Individual tutor"
    },
    "defaultLanguage": "Default language",
    "timezone": "Timezone",
    "gradingScale": "Grading scale",
    "gradingScales": {
      "points": "Points",
      "ua_12": "Ukrainian 12-point scale"
    },
    "gradingScaleNote": "The grading scale only changes how grades are displayed — every score is stored as points, so switching it never rewrites a grade. Everyone in the school sees the new scale straight away.",
    "gradingScaleSaved": "Grading scale updated",
    "gradingScaleFailed": "Could not change the grading scale"
  },
  "createSchool": {
    "title": "Create your school",
    "description": "Set up a workspace for your school or private practice — you'll be its administrator.",
    "name": "School name",
    "namePlaceholder": "e.g. Shevchenko Lyceum",
    "type": "Type",
    "typeOrganization": "Organization — a school with a staff of teachers",
    "typeIndividual": "Individual — a single tutor running their own classes",
    "defaultLanguage": "Default language",
    "submit": "Create school",
    "submitting": "Creating…",
    "failed": "Could not create the school",
    "validation": {
      "nameRequired": "School name is required"
    }
  },
  "safety": {
    "title": "Safety",
    "pupilDirectMessages": "Allow pupils to message each other privately",
    "pupilDirectMessagesNote": "When this is on, any two pupils in this school can open a private conversation that no teacher is part of. It is off by default. Pupils can always message teachers and admins, and can always reach their own parent, whether or not this is on.",
    "pupilDirectMessagesOn": "Pupil-to-pupil private messaging is now on for this school.",
    "pupilDirectMessagesOff": "Pupil-to-pupil private messaging is now off for this school.",
    "saveFailed": "Could not save that setting.",
    "moderationLink": "Review reported messages"
  },
  "years": {
    "title": "Academic years",
    "description": "Years organize classes: every class belongs to one year, and the current year is what new classes and lists default to. Grades and attendance follow the class automatically.",
    "add": "Add year",
    "empty": "No academic years yet.",
    "current": "Current",
    "makeCurrent": "Make current",
    "currentSet": "{{name}} is now the current year.",
    "edit": "Edit {{name}}",
    "delete": "Delete {{name}}",
    "deleteTitle": "Delete {{name}}?",
    "deleteDescription": "Only a year without classes can be deleted — a year with classes is part of their history.",
    "deleteConfirm": "Delete",
    "deleted": "Academic year deleted.",
    "createTitle": "Add academic year",
    "editTitle": "Edit academic year",
    "formDescription": "Name the year the way your school says it, e.g. 2026–2027.",
    "nameLabel": "Name",
    "namePlaceholder": "2026–2027",
    "startsLabel": "Starts",
    "endsLabel": "Ends",
    "createSubmit": "Add year",
    "saveSubmit": "Save",
    "created": "Academic year added.",
    "updated": "Academic year updated.",
    "saveFailed": "Could not save the academic year.",
    "validation": {
      "nameRequired": "A name is required.",
      "datesRequired": "Both dates are required."
    }
  }
}
